import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { AppLayout } from "@/components/shared/app-layout";
import { AuthGuard } from "@/guards/auth-guard";
import { UserConsentGuard } from "@/guards/user-consent-guard";
import { pageAtRouteMap } from "@/pages";
import ErrorPage from "@/pages/error-page";
import PageNotFoundPage from "@/pages/page-not-found-page";
import { routeNames, routes } from "@/routes";

/**
 * Create an array of objects with path and component properties
 */
const pages = routeNames.map((routeName) => {
    const Component = pageAtRouteMap[routeName];
    return {
        path: routes[routeName].path,
        element: <Component />,
        errorElement: <ErrorPage />,
    };
});

// Define router using createBrowserRouter
const router = createBrowserRouter([
    {
        element: (
            <AuthGuard>
                <UserConsentGuard>
                    <AppLayout />
                </UserConsentGuard>
            </AuthGuard>
        ),
        children: [
            ...pages, // Spread generated routes
            { path: "*", element: <PageNotFoundPage /> }, // 404 fallback
        ],
    },
]);

export const AppRoutes = () => <RouterProvider router={router} />;
